import { createSelector } from 'reselect';

export const deviceSelector = state => state?.device;

export const deviceCustomSelector = createSelector(
  deviceSelector,
  (_, key) => key,
  (device, key) => device.find(prop => prop === key),
);
